import { Outlet, Link } from 'react-router-dom';
import { BrandLogo } from '@/components/common/BrandLogo';
import { ROUTES } from '@/constants';

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[var(--background)] px-4 py-10">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgb(197_160_89_/_0.14),_transparent_45%),linear-gradient(180deg,_rgb(247_248_250),_rgb(232_236_242))] dark:bg-[radial-gradient(circle_at_top,_rgb(197_160_89_/_0.12),_transparent_40%),linear-gradient(180deg,_#030712,_#050d18)]"
      />
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <Link to={ROUTES.HOME}>
            <BrandLogo
              variant="stacked"
              size="lg"
              showTagline
              className="items-center"
            />
          </Link>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
